import { Condition } from "./condition";

export enum JoinOperatorValues {
  AND = "and",
  OR = "or",
}

export class Criteria {
  private join_operator: string;
  private conditions: Condition[];
  observers: Set<() => void>;

  constructor(join_operator: string, conditions: Condition[]) {
    this.observers = new Set();
    this.setLogicalOperator(join_operator);
    this.setConditions(conditions);
  }

  getLogicalOperator() {
    return this.join_operator;
  }

  getConditions() {
    return this.conditions;
  }

  setLogicalOperator(join_operator: string) {
    this.join_operator = join_operator;
  }

  setConditions(conditions: Condition[]) {
    this.conditions = conditions;
    this.notifyObservers();
  }

  toJSON() {
    return {
      join_operator: this.join_operator,
      conditions: this.conditions
        .filter((condition) => {
          const input = condition.getUserInput();
          return (
            input !== null &&
            input !== undefined &&
            input.toString().trim() !== ""
          );
        })
        .map((condition) => condition.toJSON()),
    };
  }

  addObserver(observer: () => void) {
    this.observers.add(observer);
  }

  removeObserver(observer: () => void) {
    this.observers.delete(observer);
  }

  notifyObservers() {
    this.observers.forEach((observer) => observer());
  }
}
